export default __webpack_public_path__ + "static/media/Complete-approach.088389e9.png";